import { useTranslation } from 'react-i18next';
import { Trophy } from 'lucide-react';

import { useGetLeaderboardQuery, useGetMeQuery } from '@/services/qgammonApi';
import { Loader } from '@/components/common/Loader';
import { cn } from '@/lib/cn';

/** Hub "Classifica" section for Backgammon: ELO leaderboard, own row highlighted. */
export function QgammonLeaderboardPanel() {
  const { t } = useTranslation('backgammon');
  const { data, isLoading, isError } = useGetLeaderboardQuery();
  const { data: me } = useGetMeQuery();
  const myId = me?.user.id ?? null;
  const players = data?.players ?? [];

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto py-2">
      {isLoading && (
        <div className="flex h-32 items-center justify-center">
          <Loader />
        </div>
      )}
      {isError && (
        <p className="rounded-xl bg-bg-secondary p-4 text-center text-sm text-danger">
          {t('home.loadError')}
        </p>
      )}
      {!isLoading && !isError && players.length === 0 && (
        <p className="rounded-xl bg-bg-secondary p-4 text-center text-sm text-fg-muted">
          {t('home.empty')}
        </p>
      )}
      {players.length > 0 && (
        <ul className="divide-y divide-border overflow-hidden rounded-xl border border-border bg-bg-secondary">
          {players.map((p, i) => {
            const mine = myId !== null && p.id === myId;
            return (
              <li
                key={p.id}
                className={cn('flex items-center gap-3 px-4 py-2.5', mine && 'bg-brand/15')}
              >
                <span className="w-7 text-sm tabular-nums text-fg-muted">{i + 1}</span>
                <span className={cn('flex-1 truncate text-sm', mine ? 'font-semibold text-brand' : 'text-fg')}>
                  {p.displayName || p.username}
                </span>
                {mine && <Trophy aria-hidden className="h-3.5 w-3.5 text-brand" />}
                <span className="text-sm font-semibold tabular-nums text-brand">{p.elo}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
